import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {BusinessProcessService} from '../../../../services/business-process.service';
import {Utils} from '../../../../services/utils';
import {DateTimeService} from '../../../../services/date-time.service';

@Component({
  selector: 'app-review-modal',
  templateUrl: './review-modal.component.html',
  styleUrls: ['./review-modal.component.css', '../../../../styles/modals.css']
})
export class ReviewModalComponent implements OnInit {

  @Input() modalTitle: string;
  @Input() data: any;

  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.data = this['objInitialState'];
  }

  onClose() {
    this.bsModalRef.hide();
  }

}
